<button type="button" [class]="buttonClass" (click)="createTicket($event)" [disabled]="disabled || loading">
  @if (icon) {
    <fa-icon [icon]="icon" [appShowFaSpinner]="loading" [fixedWidth]="true"/>
  }
  @if (text) {
    {{ (text | messageTranslate) }}
  }
</button>
